import HousingDatabaseCom from "components/housing-database/HousingDatabase";
import React from "react";

const HousingDatabase = () => {
  return (
    <>
      <div className="main-contents">
        <h1>Property Database</h1>
        <HousingDatabaseCom />
      </div>
    </>
  );
};

export default HousingDatabase;
